import cmfApi from "../index";

const API_URL = "/agencies";

function getAgencies(token, id, region) {
	const config = {
		headers: {
			Accept: "application/json",
			Authorization: `Bearer ${token}`,
		},
	};


	const URL = id
		? `${API_URL}/${id}`
		: region
		? `${API_URL}/by/region/${region}`
		: API_URL;

	return new Promise(function (resolve, reject) {
		cmfApi.get(URL, config).then(
			(response) => {
				var result = response.data;
				resolve(result);
			},
			(error) => {
				reject(error);
			}
		);
	});
}

export { getAgencies };
